module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-play-fill-de73cb4b.svg";